import { ReducerPaths } from '$store/constants/reducerPaths';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BrandInitialState = {
  brandName: string;
  displayName: string;
  logoUrl: string;
  currency: string;
  currencyCode: string;
  locale: string;
  usdToCurrencyConverter: (amount: number) => number;
  currencyToUsdConverter: (amount: number) => number;
};

type CurrencyUpdate = {
  currency: string;
  currencyCode: string;
  usdToCurrencyConverter: (amount: number) => number;
  currencyToUsdConverter: (amount: number) => number;
};

const initialState = {
  brandName: '',
  displayName: '',
  logoUrl: '',
  currency: '$',
  currencyCode: 'USD',
  locale: 'USD',
  usdToCurrencyConverter: (amount: number) => amount,
  currencyToUsdConverter: (amount: number) => amount,
};

const BrandSlice = createSlice({
  initialState,
  name: ReducerPaths.BRAND,
  reducers: {
    setBrand: (state, action: PayloadAction<BrandInitialState>) => {
      state.brandName = action.payload.brandName;
      state.displayName = action.payload.displayName;
      state.logoUrl = action.payload.logoUrl;
      state.currency = action.payload.currency;
      state.currencyCode = action.payload.currencyCode;
      state.usdToCurrencyConverter = action.payload.usdToCurrencyConverter;
      state.currencyToUsdConverter = action.payload.currencyToUsdConverter;
      state.locale = action.payload.locale;
    },
    updateCurrency: (state, action: PayloadAction<CurrencyUpdate>) => {
      state.currency = action.payload.currency;
      state.currencyCode = action.payload.currencyCode;
      state.usdToCurrencyConverter = action.payload.usdToCurrencyConverter;
      state.currencyToUsdConverter = action.payload.currencyToUsdConverter;
    },
  },
});

export default BrandSlice;
